define('SC.AboutUs.1.0.0.AboutUs', [
    'AboutUs.Router'
], function AboutUs(
    Router
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            return new Router(application);
        }
    };
});
